<template>
  <div v-if="leftBox" class="back-box" @click="closeOverlay()">
    <img
      class="go-back-img"
      src="@/assets/icons-general/icon-close-cross-grey.svg"
      alt="icon close"
    />
  </div>
  <div v-if="!leftBox" class="back-box" @click="goBack()">
    <img class="go-back-img" src="@/assets/icons-general/icon-back.svg" alt="icon back" />
  </div>
  <button class="reset-button-style-mobile" @click="resetAll()">
    {{ $t('general__data__reset-all-choices') }}
  </button>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'

interface EMITS {
  (e: 'closeOverlay')
  (e: 'resetAll')
  (e: 'goBack')
}
const emits = defineEmits<EMITS>()
interface PROPS {
  leftBox: boolean
}
const props = defineProps<PROPS>()
const { leftBox } = toRefs(props)

function closeOverlay() {
  emits('closeOverlay')
}

function resetAll() {
  emits('resetAll')
}
function goBack() {
  emits('goBack')
}
</script>

<style lang="scss" scoped>
.back-box {
  display: flex;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #f8f8f8;
  border-radius: 6px;
}
.reset-button-style-mobile {
  background: #2f363b;
  border: 1px solid #ffffff;
  border-radius: 4px;
  color: white;
  height: 24px;
  font-size: 14px;
  font-weight: 400;
  font-family: Raleway;
}
.go-back-img {
  padding: 10px;
}
</style>
